import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import Page from '@aboutyou/legacy-desktop/src/app/pages/Drops/DropsOverviewPage';
import {redialDropOverview} from '@aboutyou/legacy-desktop/src/app/pages/Drops/redial';
import React from 'react';
import redial from 'redial';
import {NotFound} from '../../app/components/pages/NotFoundPage/NotFound';
import {withLegacyProviders} from '../LegacyComponentWrapper';

const PageWithRedial = redial.provideHooks(redialDropOverview)(Page);

const DropsOverviewPageWithLegacyProviders =
  withLegacyProviders(PageWithRedial);

export const DropsOverviewPage: React.FC<React.PropsWithChildren> = props => {
  return useIsSoftFeatureToggleActive('disable_drops_entry') ? (
    <NotFound />
  ) : (
    <DropsOverviewPageWithLegacyProviders {...props} />
  );
};
